import React from 'react';
import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import {getTranslation} from "../lang/main";

class PaginationItem extends React.Component {
    getClassNames() {
        let classNames = 'pagination__item';
        classNames += ` ${
            this.isActive() === true ? 'pagination__item--active' : ''
        }`;

        return classNames;
    }
    isActive() {
        const { activePage, pageNumber } = this.props;
        const isActive = activePage == pageNumber;

        return isActive;
    }
    onClick(e) {
        const { onClick, pageNumber } = this.props;

        if (this.isActive()) {
            return;
        }

        if (onClick) {
            e.preventDefault();
            onClick(pageNumber);
        }
    }
    render() {
        const { pageNumber } = this.props;

        return (
            <a
                onClick={(e) => this.onClick(e)}
                className={this.getClassNames()}
                title={`Page ${pageNumber}`}
            >
                {pageNumber}
            </a>
        );
    }
}

class SectionPagination extends React.Component {
    hasNextPage() {
        const { activePage, totalPages } = this.props;

        return activePage < totalPages;
    }
    hasPrevPage() {
        const { activePage } = this.props;

        return activePage > 1;
    }
    onNextClick(e) {
        const { activePage, onPaginationClick, totalPages } = this.props;

        if (activePage >= totalPages) {
            return;
        }

        if (onPaginationClick) {
            onPaginationClick(activePage + 1);
            this.nextButton.blur();
        }
    }
    onPrevClick(e) {
        const { activePage, onPaginationClick } = this.props;

        if (activePage <= 1) {
            return;
        }

        if (onPaginationClick) {
            onPaginationClick(activePage - 1);
            this.prevButton.blur();
        }
    }
    render() {
        const { pages, activePage, onPaginationClick } = this.props;

        // hide pagination when only 1 page        
        if (pages.length === 1 && pages[0] === 1) {
            return null;
        }

        return (
            <div className='pagination'>
                <div className='pagination__container'>
                    <button
                        ref={(r) => (this.prevButton = r)}
                        type='button'
                        className='pagination__nav pagination__nav--prev hidden-xs'
                        title={getTranslation('PREV')}
                        disabled={!this.hasPrevPage()}
                        onClick={(e) => this.onPrevClick(e)}
                    >
                        <LocalizedMessage id={'PREV'} />
                    </button>
                    <button
                        ref={(r) => (this.nextButton = r)}
                        type='button'
                        className='pagination__nav pagination__nav--next hidden-xs'
                        title={getTranslation('NEXT')}
                        disabled={!this.hasNextPage()}
                        onClick={(e) => this.onNextClick(e)}
                    >
                        <LocalizedMessage id={'NEXT'} />
                    </button>
                    <div className='pagination__pages'>
                        {pages.map((item, key) => {
                            const paginationItemKey = `${item}-${key}`;

                            return (
                                <PaginationItem
                                    key={paginationItemKey}
                                    activePage={activePage}
                                    pageNumber={item}
                                    onClick={(pageNumber) =>
                                        onPaginationClick(pageNumber)
                                    }
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

// default props
SectionPagination.defaultProps = {
    activePage: 1,
    pages: [],
};
// validate props
SectionPagination.propTypes = {
    activePage: PropTypes.number,
    pages: PropTypes.array,
    onPaginationClick: PropTypes.func,
};

export default SectionPagination;
